import * as React from 'react';

import { Heading } from '../../../../../../../components/Heading/Heading';
import { CloseIcon } from '../../../../../../../components/Icons/CloseIcon';
import { SearchIcon } from '../../../../../../../components/Icons/SearchIcon';

interface IProps {
  className?: string;
  onChange: (species: string) => void;
  speciesFilter: string;
}

export const FilterBySpecies = ({ className = '', onChange, speciesFilter }: IProps) => {
  return (
    <div className={className}>
      <Heading variant="2xs" className="mt-5">
        Filter by species
      </Heading>
      <div className="input-wrapper bg-sea-foam relative my-3 mr-4 flex h-[38px] w-full max-w-lg items-center rounded-lg">
        <span className="search-icon p-4">
          <SearchIcon width={14} height={14} />
        </span>
        <input
          placeholder="Search species"
          type="text"
          value={speciesFilter}
          onChange={e => {
            onChange(e.target.value);
          }}
          className="w-full"
        />
        {speciesFilter && (
          <button
            type="button"
            data-testid="close"
            className="absolute right-4"
            onClick={() => {
              onChange('');
            }}
          >
            <CloseIcon />
          </button>
        )}
      </div>
    </div>
  );
};
